// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ssrs_package_select[data-v-6afa13c2]  .vs__dropdown-option{text-wrap:wrap!important}.ssrs_package_select[data-v-6afa13c2]  .vs__dropdown-option--selected,.ssrs_package_select[data-v-6afa13c2]  .vs__dropdown-option--selected.vs__dropdown-option--highlight{color:#000!important}", ""]);
// Exports
module.exports = exports;
